// lbl.profile
export const profile = {
    tips_coins: 'TIP Coins',
    point_not_expire: 'คะแนนไม่มีวันหมดอายุ',
    edit: "แก้ไข",
    birth_date: 'วันเกิด',
    contact_number: 'เบอร์โทรศัพท์',
    email: 'อีเมล',
    password_no: 'หมายเลข passport',
    coin_history: 'ประวัติคะแนน',
    coin_tranfer: 'โอนคะแนน',
    my_insurance: 'กรมธรรม์ของฉัน',
    refresh: 'รีเฟรช',
    carried: 'รายการ',
    no_data: 'ไม่มีข้อมูล',
    member_name: 'ผู้เอาประกันภัย : ',
    policy_name: 'เลขที่กรมธรรม์ : ',
    vehicle_number: 'เลขทะเบียนรถยนต์  :',
    effective_date : 'วันที่คุ้มครอง : ',
    expire_date : 'วันที่สิ้นสุด : ',
    insuenace_term: 'ความคุ้มครองเป็นไปตามเงื่อนไขกรมธรรม์',
    renewal_insurance: 'ต่ออายุ',
    privacy_policies: 'นโยบายทางด้านข้อมูลส่วนบุคคล',
    term_cons: 'เงื่อนไขและข้อกำหนด',
    contact_us: 'ติดต่อเรา',
    language: 'เปลี่ยนภาษา',
    en: 'EN',
    th: 'ไทย',
    delete_user: 'ยกเลิกการเป็นสมาชิก',
    sing_out: 'ออกจากระบบ',
    error: 'เกิดข้อผิดพลาด',
    call_center: 'ไม่พบข้อมูลกรมธรรม์ของท่าน กรุณาติดต่อ Call Center',
    call_center_no: 'Call Center 1736',
    sing_out_confirm: 'ยืนยันการออกจากระบบ',
    want_sing_out: 'ท่านต้องการออกจากระบบหรือไม่?',
    confirm: 'ยืนยัน',
    edit_profile: 'แก้ไขโปรไฟล์',
    save: 'บันทึก',
    confirm_edit: 'ยืนยันการบันทึกข้อมูล',
    confirm_edit2: 'ท่านต้องการยืนยันการแก้ไขข้อมูลหรือไม่?',
    save_success: 'บันทึกข้อมูลสำเร็จ',
    save_success2: 'ข้อมูลการแก้ไขโปรไฟล์ของท่านบันทึกเรียบร้อยแล้ว',
    save_not_success: 'บันทึกข้อมูลไม่สำเร็จ',
    password_desc: 'รหัสผ่านประกอบด้วย 8-20 ตัวอักษร โดยต้องใช้อักษร ตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่ และตัวเลข',
    point_not_enough: 'คะแนนของคุณไม่เพียงพอสำหรับการโอนคะแนน',
    not_customer: 'คุณไม่ได้เป็นลูกค้าของทิพยประกันภัย',
    female: 'หญิง',
    male: 'ชาย',
    thai: 'ไทย',
    foreign: 'ชาวต่างชาติ',
    password: 'รหัสผ่าน',
    pincode: 'PIN CODE'
};
